import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const PojectChartLowSingle = ({ subject, revenue, costs, yieldValue, siteManager, isLast, projectNumber }) => {
    const [showDetails, setShowDetails] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (event) => {
        setMousePosition({ x: event.clientX, y: event.clientY });
    };

    const popupContent = showDetails ? (
        <div
            className="fixed z-50 bg-gray-100 p-4 rounded shadow-lg transition-all duration-200 ease-in-out"
            style={{
                left: `${mousePosition.x}px`, // X-Position der Maus
                top: `${mousePosition.y}px`,  // Y-Position der Maus
                transform: 'translate(-100%, -100%)', // Links oben vom Cursor
                width: 'fit-content', // Dynamische Breite
            }}
        >
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm font-sans">
                <span className="font-semibold">Projekt ID:</span>
                <span>{projectNumber}</span>

                <span className="font-semibold">Standort:</span>
                <span>{siteManager?.companySite || 'N/A'}</span>

                <span className="font-semibold">Bauleiter-ID:</span>
                <span>{siteManager?.id || 'N/A'}</span>

                <span className="font-semibold">Vorname:</span>
                <span>{siteManager?.forename || 'N/A'}</span>

                <span className="font-semibold">Nachname:</span>
                <span>{siteManager?.surname || 'N/A'}</span>

                <span className="font-semibold">Umsatz:</span>
                <span>
                    EUR {parseFloat(revenue).toLocaleString('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}
                </span>

                <span className="font-semibold">Kosten:</span>
                <span>
                    EUR {parseFloat(costs).toLocaleString('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}
                </span>

                <span className="font-semibold">Rohertrag:</span>
                <span>
                    EUR {parseFloat(yieldValue).toLocaleString('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}
                </span>
            </div>
        </div>
    ) : null;

    return (
        <div
            className={`relative flex flex-col w-full py-4 ${!isLast ? 'border-b' : ''}`}
            onMouseEnter={() => setShowDetails(true)}
            onMouseLeave={() => setShowDetails(false)}
            onMouseMove={handleMouseMove} // Mausposition erfassen
            style={{ overflow: 'visible' }}
        >
            {/* Hauptinhalt */}
            <div className="flex justify-between">
                <div>{subject}</div>
                <div className={yieldValue < 0 ? 'text-red-700' : ''}>
                    EUR {parseFloat(yieldValue).toLocaleString('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}
                </div>
            </div>

            {/* Popup wird außerhalb des Containers gerendert */}
            {createPortal(popupContent, document.body)}
        </div>
    );
};

export default PojectChartLowSingle;